import { SET_PRODUCTS, SET_BASKET_PRODUCTS } from '../actions/product';

let initialState = {
  productsData: [],
  basketProductsData: [],
};

const product = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        productsData: action.payload,
      };

    case SET_BASKET_PRODUCTS:
      return {
        ...state,
        basketProductsData: action.payload,
      };

    default:
      return state;
  }
};

export default product;
